import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { getParamsFromQueryString } from './utils/url'
import { languages } from './i18n'
import { setLang, logout } from './store/auth/actions'
import GenericMessage from './components/shared/GenericMessage'
import Routes from './routes/Routes'
import { bindActionCreators } from 'redux'

const { app_id: appId } = getParamsFromQueryString()

const mapStateToProps = state => ({
  lang: state.auth.lang,
  isLogged: state.auth.isLogged
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logout,
      setLang
    },
    dispatch
  )
const App = (props) => {
  const { lang, setLang, logout, isLogged } = props
  const { i18n } = useTranslation()
  React.useEffect(() => {
    const params = getParamsFromQueryString()
    if (appId === '33' && navigator.languages !== undefined && languages.includes(navigator.languages[5])) {
      setLang({ lang: navigator.languages[5] })
    } else if (params.lang && languages.includes(params.lang)) {
      setLang({ lang: params.lang })
    } else if (navigator.languages !== undefined && languages.includes(navigator.languages[0])) {
      setLang({ lang: navigator.languages[0] })
    } else if (navigator.language !== undefined && languages.includes(navigator.language)) {
      setLang({ lang: navigator.language })
    }
  }, [])
  React.useEffect(() => {
    if (languages.includes(lang)) {
      i18n.changeLanguage(lang)
    }
  }, [lang])

  let url
  if (typeof window !== 'undefined') {
    url = window.location.pathname
  }

  if (url && url.includes('recover_password')) {
    localStorage.clear()
    isLogged && logout()
  }
  return (
    <Router>
      <div>
        <Routes />
        <GenericMessage />
      </div>
    </Router>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
